import React from "react";
import AmlTable from "../AmlTable";
import { Box } from "@mui/material";

const SearchAml = ({ handleOpenLegendaModal, allAml }) => {
  return (
    <Box sx={{ width: "100%" }}>
      <AmlTable
        data={allAml}
        onStatusInfoClick={handleOpenLegendaModal}
        emptyMessage="Nessun risultato trovato"
        columns={[
          "id",
          "stato",
          "cliente",
          "email",
          "data",
          "scadenza",
          "approved_at",
        ]}
      />
    </Box>
  );
};

export default SearchAml;
